define('models/ConfigurationModel',['underscore','ObjectModel','LocalStorage'],function (_,ObjectModel,LocalStorage) {
    //
    // Model Configuration
    //
    var ConfigurationModelPrototype = {

        name:'ConfigurationModel',
        idAttribute:'name',
        defaults:{
            value:'',
        },
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        }
    };

    var ConfigurationModel = ObjectModel.extend(LocalStorage).extend(ConfigurationModelPrototype);

    return ConfigurationModel;
});
